import React from "react";
import { useTranslation } from "react-i18next";
import { color } from "../../styles/theme";

/** Small inline empty-state, replaces every page's own "None yet." <p>. */
const EmptyState = ({ icon: Icon, text }) => {
  const { t } = useTranslation("common");
  return (
    <div style={s.wrap}>
      {Icon && <Icon size={22} strokeWidth={1.75} color={color.gray400} />}
      <span style={s.text}>{text ?? t("status.nothingHere")}</span>
    </div>
  );
};

const s = {
  wrap: { display: "flex", flexDirection: "column", alignItems: "center", gap: 8, padding: "22px 0", color: color.textMuted },
  text: { fontSize: 12.5, fontWeight: 500 },
};

export default EmptyState;
